import styled from 'styled-components';
import {dFlex, flexColumn, alignStart} from '../../../../../../globalVariables/GlobalFlex';
import {getToken, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';
import { section } from '../PricingStep/PricingStep.css';


export const timeLineSection = styled(section)`
    background: transparent;
`;
export const validityHeader = styled.div`
    ${dFlex};
    ${flexColumn};
    ${alignStart};
    gap: ${getSpacing('spaceSm')};
    width: 100%;
`;

export const validityTitle = styled.h2`
    font-size: ${getFontSize('bodySmall')};
    font-weight: ${getFontWeight('bold')};
    color: ${getToken('color.text.default')};
    margin: 0;
`;

export const lifecycleSubtitle = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.default')};
`;

